module.exports = __webpack_public_path__ + "static/img/ARAD-S4_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD-S4_2.png
// module id = 7UC1
// module chunks = 0